import { useState, useEffect, useContext } from "react";
import { Style } from "react-style-tag";
import { Editor } from "@craftjs/core";
import lz from "lzutf8";
import ButtonBlock from "@/components/editor/blocks/ButtonBlock";
import SocialMediaBlock from "@/components/editor/blocks/SocialMediaBlock";
import MapBlock from "@/components/editor/blocks/MapBlock";
import FaqsBlock from "@/components/editor/blocks/FaqsBlock";
import DishBlock from "@/components/editor/blocks/DishBlock";
import MenuBlock from "@/components/editor/blocks/MenuBlock";
import CartBlock from "@/components/editor/blocks/CartBlock";
import ContainerBlock from "@/components/editor/blocks/ContainerBlock";
import TextBlock from "@/components/editor/blocks/TextBlock";
import ImageBlock from "@/components/editor/blocks/ImageBlock";
import VerticalSpacerBlock from "@/components/editor/blocks/VerticalSpacerBlock";
import SectionBlock from "@/components/editor/blocks/section-block/SectionBlock";
import RenderNode from "@/features/websites/components/RenderNode";
import Canvas from "./components/Canvas";
import { WebsiteContext } from "./WebsiteProvider";
import ProductDetails from "@/features/product-details/ProductDetails";
import RegionBlock from "@/components/editor/blocks/RegionBlock";
import OffersPopups from "@/components/OffersPopups";
import OrganizationThemeProvider from "@/providers/OrganizationThemeProvider";

const Website = () => {
  const [json, setJson] = useState();
  const { website } = useContext(WebsiteContext);

  useEffect(() => {
    if (website?.data) {
      const json = lz.decompress(lz.decodeBase64(String(website?.data)));
      setJson(json);
    }
  }, [website?.data]);

  return (
    <>
      <OrganizationThemeProvider>
        <Editor
          resolver={{
            SectionBlock,
            ContainerBlock,
            TextBlock,
            ImageBlock,
            VerticalSpacerBlock,
            ButtonBlock,
            SocialMediaBlock,
            MapBlock,
            FaqsBlock,
            DishBlock,
            MenuBlock,
            CartBlock,
            RegionBlock,
          }}
          enabled={false}
          onRender={RenderNode}
        >
          <Style className="viewport" children={website?.styles ?? ""} />
          {json ? <Canvas json={json} /> : null}
        </Editor>
        <ProductDetails />
      </OrganizationThemeProvider>
      <OffersPopups />
    </>
  );
};

export default Website;
